module.exports = __webpack_public_path__ + "img/612-img-1b.7cb6a844.jpg";